// src/contexts/index.tsx
import React from 'react';
import stores from '../stores';

export const storesContext = React.createContext(stores);
